import { useState, useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { useParams, useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import { getCasinoResultReport, getDetailResults } from '../../apiservices/CasionApi'
import RefDatePicker from '../../components/RefDatePicker'
import RefResultModal from '../casinoComponents/refResultModal'
import ResultBodyByType from '../casinoComponents/refResultModal/resultBodyByType'
import { formatRefMatchTime } from '../../utils/refMatchTime'
import ResultModalLayout from '../../components/resultModalLayout'
import CasinoResultBodyByGameType from '../casinoComponents/casinoResultModal/CasinoResultBodyByGameType'

import './style.css'

// Map API win "1"/"2" to display for table (I/E for Super Over 2/3, A/B for others)
const mapWinDisplay = (win, gameType) => {
  const norm = (gameType || '').toLowerCase().trim()
  if (norm === 'superover2' || norm === 'superover3') {
    return win === '1' ? 'I' : win === '2' ? 'E' : win || '-'
  }
  if (norm === 'race20' || norm === 'race17' || norm === 'vrace17' || norm === 'race2') {
    const suitMap = { '1': 'Spade', '2': 'Heart', '3': 'Club', '4': 'Diamond' }
    return suitMap[win] || win || '-'
  }
  return win === '1' ? 'A' : win === '2' ? 'B' : win || '-'
}

// Game type options for select (value => label), same as admin casino dropdown
const CASINO_OPTIONS = [
  { value: 'teen', label: 'Teenpatti 1-day' },
  { value: 'poker', label: 'Poker 1-Day' },
  { value: '3cardj', label: '3 Cards Judgement' },
  { value: 'aaa', label: 'Amar Akbar Anthony' },
  { value: 'ab20', label: 'Andar Bahar' },
  { value: 'abj', label: 'Andar Bahar 2' },
  { value: 'baccarat', label: 'Baccarat' },
  { value: 'baccarat2', label: 'Baccarat 2' },
  { value: 'btable', label: 'Bollywood Casino' },
  { value: 'card32', label: '32 Cards A' },
  { value: 'card32eu', label: '32 Cards B' },
  { value: 'cmatch20', label: 'Cricket Match 20-20' },
  { value: 'cmeter', label: 'Casino Meter' },
  { value: 'cricketv', label: 'Cricket V' },
  { value: 'cricketv2', label: 'Cricket V2' },
  { value: 'cricketv3', label: '5Five Cricket' },
  { value: 'dt20', label: '20-20 Dragon Tiger' },
  { value: 'dt202', label: '20-20 Dragon Tiger 2' },
  { value: 'dt6', label: '1 Day Dragon Tiger' },
  { value: 'dtl20', label: '20-20 D T L' },
  { value: 'lottcard', label: 'lottcard' },
  { value: 'lucky7', label: 'Lucky 7 - A' },
  { value: 'lucky7eu', label: 'Lucky 7 - B' },
  { value: 'poker20', label: '20-20 Poker' },
  { value: 'poker6', label: 'Poker 6 Players' },
  { value: 'teen20', label: '20-20 Teenpatti' },
  { value: 'teen8', label: 'Teenpatti Open' },
  { value: 'teen9', label: 'Teenpatti Test' },
  { value: 'war', label: 'Casino War' },
  { value: 'worli', label: 'Worli Matka' },
  { value: 'worli2', label: 'Instant Worli' },
  { value: 'teen6', label: 'Teenpatti - 2.0' },
  { value: 'queen', label: 'Queen' },
  { value: 'race20', label: 'Race20' },
  { value: 'pop-the-ball', label: 'Pop The Ball' },
  { value: 'lucky7eu2', label: 'Lucky 7 - C' },
  { value: 'superover', label: 'Super Over' },
  { value: 'trap', label: 'The Trap' },
  { value: 'patti2', label: '2 Cards Teenpatti' },
  { value: 'teensin', label: '29Card Baccarat' },
  { value: 'teenmuf', label: 'Muflis Teenpatti' },
  { value: 'race17', label: 'Race to 17' },
  { value: 'teen20b', label: '20-20 Teenpatti B' },
  { value: 'trio', label: 'Trio' },
  { value: 'notenum', label: 'Note Number' },
  { value: 'teen2024', label: 'Teen 20 24' },
  { value: 'kbc', label: 'K.B.C' },
  { value: 'teen120', label: '1 CARD 20-20' },
  { value: 'teen1', label: '1 CARD ONE-DAY' },
  { value: 'vteen20', label: 'V-20-20 Teenpatti' },
  { value: 'vteen', label: 'V-Teenpatti 1-day' },
  { value: 'vdt6', label: 'V-1 Day Dragon Tiger' },
  { value: 'vdt20', label: 'V-20-20 Dragon Tiger' },
  { value: 'vlucky7', label: 'V-Lucky 7 - A' },
  { value: 'vrace17', label: 'V-Race to 17' },
  { value: 'vteenmuf', label: 'V-Muflis Teenpatti' },
  { value: 'vaaa', label: 'V-Amar Akbar Anthony' },
  { value: 'vbtable', label: 'V-Bollywood Casino' },
  { value: 'vbaccarat', label: 'V-Baccarat' },
  { value: 'vtrio', label: 'V-Trio' },
  { value: 'vtrap', label: 'V-The Trap' },
  { value: 'ab3', label: 'ANDAR BAHAR 50 CARDS' },
  { value: 'vdtl20', label: 'V-20-20 D T L' },
  { value: 'aaa2', label: 'Amar Akbar Anthony 2' },
  { value: 'roulette', label: 'roulette' },
  { value: 'race2', label: 'Race to 2nd' },
  { value: 'teen3', label: 'Instant Teenpatti' },
  { value: 'dum10', label: 'Dus ka Dum' },
  { value: 'cmeter1', label: '1 Card Meter' },
  { value: 'teen32', label: 'instant teenpatti 2.0' },
  { value: 'sicbo', label: 'Sic Bo' },
  { value: 'ballbyball', label: 'Ball By Ball' },
  { value: 'roulette1', label: 'roulette1' },
  { value: 'teen33', label: 'Instant Teenpatti 3.0' },
  { value: 'roulette2', label: 'roulette2' },
  { value: 'superover2', label: 'Super Over2' },
  { value: 'sicbo2', label: 'Sic Bo 2' },
  { value: 'roulette3', label: 'roulette3' },
  { value: 'teen41', label: 'Queen top open teenpatti' },
  { value: 'teen42', label: 'Jack top open teenpatti' },
  { value: 'lucky15', label: 'Lucky 15' },
  { value: 'goal', label: 'Goal' },
  { value: 'ab4', label: 'ANDAR BAHAR 150 CARDS' },
  { value: 'superover3', label: 'mini super over' },
  { value: 'ourroullete', label: 'Unique Roulette' },
  { value: 'teen20c', label: '20-20 Teenpatti C' },
  { value: 'btable2', label: 'Bollywood Casino 2' },
  { value: 'teenjoker', label: 'Teenpatti Joker' },
  { value: 'joker1', label: 'Unlimited Joker One Day' },
  { value: 'joker20', label: 'Teenpatti Joker 20-20' },
  { value: 'joker120', label: 'Unlimited Joker 20-20' },
  { value: 'poison20', label: 'Teenpatti Poison 20-20' },
  { value: 'roulette11', label: 'VIP Roulette' },
  { value: 'teenunique', label: 'Unique Teenpatti' },
  { value: 'poison', label: 'Teenpatti Poison One Day' },
  { value: 'roulette12', label: 'Beach Roulette' },
  { value: 'roulette13', label: 'Regular Roulette' },
  { value: 'pteen', label: 'Premium Teenpatti 1-day' },
  { value: 'pteen20', label: 'Premium 20-20 Teenpatti' },
  { value: 'pdt6', label: 'Premium 1 Day Dragon Tiger' },
  { value: 'pdt20', label: 'Premium 20-20 Dragon Tiger' },
  { value: 'plucky7', label: 'Premium Lucky 7' },
  { value: 'pcard32', label: 'Premium 32 Cards' },
  { value: 'pbaccarat', label: 'Premium Baccarat' },
  { value: 'tteen', label: 'Tembo Teenpatti 1-day' },
  { value: 'tteen20', label: 'Tembo 20-20 Teenpatti' },
  { value: 'tdt6', label: 'Tembo 1 Day Dragon Tiger' },
  { value: 'tdt20', label: 'Tembo 20-20 Dragon Tiger' },
  { value: 'tlucky7', label: 'Tembo Lucky 7' },
  { value: 'tcard32', label: 'Tembo 32 Cards' },
  { value: 'tbaccarat', label: 'Tembo Baccarat' },
  { value: 'lucky5', label: 'Lucky 6' },
  { value: 'mogambo', label: 'Mogambo' },
  { value: 'dolidana', label: 'Dolidana' },
  { value: 'teen20v', label: '20-20 Teenpatti VIP' },
  { value: 'worli3', label: 'Matka' },
  { value: 'teen62', label: 'V VIP Teenpatti 1-day' },
  { value: 'goal2', label: 'Goal 2' },
  { value: 'exanew1', label: 'EXA Live' },
  { value: 'exanew2', label: 'EXA Fantasy' },
  { value: 'exanew3', label: 'EXA Slot' },
  { value: 'teenholdem', label: 'Teenpatti Holdem' },
]

const pad2 = (n) => String(n).padStart(2, '0')
const apiDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`

/**
 * bootstrap-vue <b-pagination> page list (limit 5, ellipsis): which page numbers to show,
 * whether to show the leading / trailing "…", and which items get bv-d-xs-down-none.
 */
function bvPageList(numberOfPages, currentPage, limit = 5) {
  let showFirstDots = false
  let showLastDots = false
  let numberOfLinks = limit
  let startNumber = 1
  if (numberOfPages <= limit) {
    numberOfLinks = numberOfPages
  } else if (currentPage < limit - 1 && limit > 3) {
    showLastDots = true
    numberOfLinks = limit - 1
  } else if (numberOfPages - currentPage + 2 < limit && limit > 3) {
    showFirstDots = true
    numberOfLinks = limit - 1
    startNumber = numberOfPages - numberOfLinks + 1
  } else {
    if (limit > 3) {
      numberOfLinks = limit - 2
      showFirstDots = true
      showLastDots = true
    }
    startNumber = currentPage - Math.floor(numberOfLinks / 2)
  }
  if (startNumber < 1) {
    startNumber = 1
    showFirstDots = false
  } else if (startNumber > numberOfPages - numberOfLinks) {
    startNumber = numberOfPages - numberOfLinks + 1
    showLastDots = false
  }
  const pages = Array.from({ length: numberOfLinks }, (_, i) => ({ number: startNumber + i, xsHidden: false }))
  // b-pagination hides some numbers on xs: keep the current page and its neighbours
  if (pages.length > 3) {
    const idx = currentPage - startNumber
    if (idx === 0) {
      for (let i = 3; i < pages.length; i++) pages[i].xsHidden = true
    } else if (idx === pages.length - 1) {
      for (let i = 0; i < pages.length - 3; i++) pages[i].xsHidden = true
    } else {
      for (let i = 0; i < idx - 1; i++) pages[i].xsHidden = true
      for (let i = pages.length - 1; i > idx + 1; i--) pages[i].xsHidden = true
    }
  }
  return { pages, showFirstDots, showLastDots }
}

const SORT_LABEL = { none: ' (Click to sort ascending)', ascending: ' (Click to sort descending)', descending: ' (Click to sort ascending)' }

/**
 * Casino Result Report — reference markup (allpanel9 admin /reports/casinoresult/:type):
 * date picker + casino select + Submit, b-table (sortable Market Id / Winner) and b-pagination.
 * Data: one day's rounds for the chosen game from the existing result-report endpoint.
 * URL: /admin/reports/casinoresult or /admin/reports/casinoresult/:gameName (e.g. .../pteen)
 */
function CasinoResultReport() {
  const { gameName } = useParams()
  const navigate = useNavigate()
  const [entriesPerPage, setEntriesPerPage] = useState(25)
  const [searchValue, setSearchValue] = useState('')
  const [gameType, setGameType] = useState(() =>
    gameName && CASINO_OPTIONS.some((o) => o.value === gameName) ? gameName : ''
  )
  const [selectedDate, setSelectedDate] = useState(() => new Date())
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [sort, setSort] = useState({ key: null, dir: 'none' })
  const [showModal, setShowModal] = useState(false)
  const [selectedRoundId, setSelectedRoundId] = useState(null)
  const [detailResult, setDetailResult] = useState(null)
  const [modalLoading, setModalLoading] = useState(false)

  // Sync gameType from URL when gameName param changes (e.g. View All from game page)
  useEffect(() => {
    if (gameName && CASINO_OPTIONS.some((o) => o.value === gameName)) setGameType(gameName)
  }, [gameName])

  const loadData = async (type, date) => {
    if (!type) return
    setLoading(true)
    try {
      const response = await getCasinoResultReport(type, apiDate(date))
      const res = response?.data?.data?.res ?? response?.data?.res ?? response?.data
      setTableData(
        Array.isArray(res)
          ? res.map((item) => ({ marketId: item.mid, winner: item.winName || mapWinDisplay(item.win, type) }))
          : []
      )
    } catch (error) {
      console.error('Error loading data:', error)
      setTableData([])
    } finally {
      setLoading(false)
    }
  }

  // Load the selected game's rounds for today on open / when the game in the URL changes
  useEffect(() => {
    loadData(gameType, selectedDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameType])

  const handleSubmit = () => loadData(gameType, selectedDate)

  // Search, sort, paginate (client side, like the reference b-table)
  const filteredData = useMemo(() => {
    const q = searchValue.trim().toLowerCase()
    const rows = q
      ? tableData.filter(
          (row) => String(row.marketId || '').toLowerCase().includes(q) || String(row.winner || '').toLowerCase().includes(q)
        )
      : tableData
    if (!sort.key || sort.dir === 'none') return rows
    const m = sort.dir === 'ascending' ? 1 : -1
    return [...rows].sort((a, b) => m * String(a[sort.key] ?? '').localeCompare(String(b[sort.key] ?? ''), undefined, { numeric: true }))
  }, [tableData, searchValue, sort])

  const totalPages = Math.max(1, Math.ceil(filteredData.length / entriesPerPage))
  const page = Math.min(currentPage, totalPages)
  const startIndex = (page - 1) * entriesPerPage
  const paginatedData = filteredData.slice(startIndex, startIndex + entriesPerPage)

  const toggleSort = (key) =>
    setSort((s) => ({ key, dir: s.key === key && s.dir === 'ascending' ? 'descending' : 'ascending' }))
  const ariaSort = (key) => (sort.key === key ? sort.dir : 'none')

  // Click Market Id: loader overlay while the round detail loads, then the result modal
  const handleRoundIdClick = async (roundId) => {
    if (!roundId || roundId === 'N/A' || !gameType) return
    setSelectedRoundId(roundId)
    setModalLoading(true)
    setDetailResult(null)
    try {
      const response = await getDetailResults(gameType, String(roundId))
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1
      if (t1) setDetailResult(t1)
    } catch (error) {
      console.error('Error fetching detail results:', error)
    } finally {
      setModalLoading(false)
      setShowModal(true)
    }
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedRoundId(null)
    setDetailResult(null)
  }

  const modalTitle = detailResult?.ename || CASINO_OPTIONS.find((o) => o.value === gameType)?.label || 'Result'
  const { pages, showFirstDots, showLastDots } = bvPageList(totalPages, page)
  const atFirst = page === 1
  const atLast = page === totalPages

  const navItem = (label, aria, target, disabled) => (
    <li role="presentation" aria-hidden={disabled ? 'true' : undefined} className={disabled ? 'page-item disabled' : 'page-item'}>
      {disabled ? (
        <span role="menuitem" aria-label={aria} aria-disabled="true" className="page-link">{label}</span>
      ) : (
        <button role="menuitem" type="button" tabIndex={-1} aria-label={aria} className="page-link" onClick={() => setCurrentPage(target)}>
          {label}
        </button>
      )}
    </li>
  )
  const dots = (
    <li role="separator" className="page-item disabled bv-d-xs-down-none">
      <span className="page-link">…</span>
    </li>
  )

  return (
    <Layout title="Casino Result Report - Diamond Admin">
      <div className="live-bets-report listing-grid report-wrapper">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0 font-size-18">Casino Result Report</h4>{' '}
              <div className="page-title-right" />
            </div>
          </div>
        </div>{' '}
        <form method="post" data-vv-scope="casinoResult" className="ajaxFormSubmit" onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
          <div className="row row5 mb-3">
            {/* "co-2" is the reference's own class name */}
            <div className="co-2 mb-2">
              <RefDatePicker name="date" value={selectedDate} onChange={setSelectedDate} />
            </div>{' '}
            <div className="col-2 mb-2">
              <select
                name="gtype"
                className="form-control"
                aria-required="true"
                aria-invalid="false"
                value={gameType}
                onChange={(e) => {
                  const val = e.target.value
                  setGameType(val)
                  navigate(val ? `/admin/reports/casinoresult/${val}` : '/admin/reports/casinoresult', { replace: true })
                }}
              >
                <option value="">Select Casino</option>
                {CASINO_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>{' '}
            <div className="col-6 mb-2">
              <button type="submit" id="loaddata" className="btn btn-primary">
                Submit
              </button>{' '}
              <div className="d-inline-block ml-3" />
            </div>
          </div>
        </form>{' '}
        <div className="row">
          <div className="col-6">
            <div id="tickets-table_length" className="dataTables_length">
              <label className="d-inline-flex align-items-center">
                Show&nbsp;
                <select
                  className="custom-select custom-select-sm"
                  value={entriesPerPage}
                  onChange={(e) => { setEntriesPerPage(Number(e.target.value)); setCurrentPage(1) }}
                >
                  {[25, 50, 75, 100, 125, 150].map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
                &nbsp;entries
              </label>
            </div>
          </div>{' '}
          <div className="col-6 text-right">
            <div id="tickets-table_filter" className="dataTables_filter text-md-right">
              <label className="d-inline-flex align-items-center">
                Search:
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control ml-1 form-control"
                  value={searchValue}
                  onChange={(e) => { setSearchValue(e.target.value); setCurrentPage(1) }}
                />
              </label>
            </div>
          </div>
        </div>{' '}
        <div className="table-responsive mb-0 report-table casino-result-table">
          <div className="table no-footer table-hover table-responsive-sm">
            <table
              id="eventsListTbl"
              role="table"
              aria-busy={loading ? 'true' : 'false'}
              aria-colcount="2"
              className="table b-table table-striped table-bordered b-table-fixed"
            >
              <thead role="rowgroup" className="">
                <tr role="row" className="">
                  {[['marketId', 'Market Id', 1], ['winner', 'Winner', 2]].map(([key, label, i]) => (
                    <th
                      key={key}
                      role="columnheader"
                      scope="col"
                      tabIndex="0"
                      aria-colindex={i}
                      aria-sort={ariaSort(key)}
                      className="position-relative"
                      onClick={() => toggleSort(key)}
                    >
                      <div>{label}</div>
                      <span className="sr-only">{SORT_LABEL[ariaSort(key)]}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody role="rowgroup">
                {paginatedData.length === 0 ? (
                  <tr role="row" className="b-table-empty-row">
                    <td colSpan="2" role="cell" className="">
                      <div role="alert" aria-live="polite">
                        <p className="text-center mb-0">No data available in table</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((row, index) => (
                    <tr key={row.marketId + '-' + index} role="row" aria-rowindex={startIndex + index + 1} className="">
                      <td aria-colindex="1" role="cell" className="">
                        <a
                          href="#"
                          className="link-default"
                          onClick={(e) => { e.preventDefault(); handleRoundIdClick(row.marketId) }}
                        >
                          {row.marketId || '-'}
                        </a>
                      </td>
                      <td aria-colindex="2" role="cell" className="">
                        {row.winner ?? '-'}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>{' '}
        <div className="row pt-3">
          <div className="col">
            <div className="dataTables_paginate paging_simple_numbers float-right">
              <ul className="pagination pagination-rounded mb-0">
                <ul role="menubar" aria-disabled="false" aria-label="Pagination" className="pagination dataTables_paginate paging_simple_numbers my-0 b-pagination justify-content-end">
                  {navItem('«', 'Go to first page', 1, atFirst)}
                  {navItem('‹', 'Go to previous page', page - 1, atFirst)}
                  {showFirstDots && dots}
                  {pages.map(({ number: n, xsHidden }) => {
                    const cls = ['page-item']
                    if (n === page) cls.push('active')
                    if (xsHidden) cls.push('bv-d-xs-down-none')
                    return (
                      <li key={n} role="presentation" className={cls.join(' ')}>
                        <button
                          role="menuitemradio"
                          type="button"
                          aria-label={`Go to page ${n}`}
                          aria-checked={n === page ? 'true' : 'false'}
                          aria-posinset={n}
                          aria-setsize={totalPages}
                          tabIndex={n === page ? 0 : -1}
                          className="page-link"
                          onClick={() => setCurrentPage(n)}
                        >
                          {n}
                        </button>
                      </li>
                    )
                  })}
                  {showLastDots && dots}
                  {navItem('›', 'Go to next page', page + 1, atLast)}
                  {navItem('»', 'Go to last page', totalPages, atLast)}
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Reference: full-page loader overlay while a round's detail loads, then the result modal
          (same body as the game page's result modal; old generic bodies only for types without one) */}
      {modalLoading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      {ResultBodyByType.has(gameType) ? (
        <RefResultModal
          modalClass=""
          show={showModal && !!detailResult}
          onHide={handleCloseModal}
          title={`${detailResult?.ename || ''} Result`.trim()} /* reference: "{{ ename }} Result", no fallback */
          roundId={detailResult?.rid}
          matchTime={formatRefMatchTime(detailResult?.mtime)}
        >
          <ResultBodyByType gameType={gameType} t1={detailResult} />
        </RefResultModal>
      ) : (
        <ResultModalLayout
          show={showModal}
          onHide={handleCloseModal}
          title={modalTitle}
          roundId={detailResult?.rid || selectedRoundId || 'N/A'}
          matchTime={detailResult?.mtime || 'N/A'}
          loading={modalLoading}
        >
          <CasinoResultBodyByGameType gameType={gameType} detailResult={detailResult} />
        </ResultModalLayout>
      )}
    </Layout>
  )
}

export default CasinoResultReport
